import { render, staticRenderFns } from "./app-text-not-recorded.vue?vue&type=template&id=221ec3bc&"
import script from "./app-text-not-recorded.vue?vue&type=script&lang=js&"
export * from "./app-text-not-recorded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./app-text-not-recorded-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Fapp%2Fapp-text-not-recorded.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports